import { isIncognitoOn } from "./app/helpers/api";
import { Theme } from "@bdfx/mergado-ui-kit";
import trans from "trans";

const checkerColor = '#ddd'
const bigCloseButton = {
    color: '#000 !important',
    position: 'absolute',
    top: '25px',
    right: '25px',
    zIndex: 501,
    pointerEvents: 'auto',
    '&::before': {
        fontSize: '20px',
        fontWeight: 'normal',
        lineHeight: '40px',
        verticalAlign: 'middle',
        padding: '8px',
        content: `"${trans('modal_close')}"`,
    },
    fontSize: '38px',
    fontWeight: 'bold',
}

export const closeButton = {
    width: 'auto',
    background: 'transparent',
    right: '15px',
    ' .muk-icon--close-light span': {
        width: 'auto',
        '&::before': {
            color: '#009ba9 !important',
            fontSize: '20px',
            fontWeight: 'normal',
            content: `"${trans('done')}"`,
            maskImage: 'none',
            background: 'transparent',
        },
    },
}

export const checkButton = {
    width: 'auto',
    background: 'transparent',
    right: '5px',
    ' .muk-icon--close-light span': {
        width: '40px',
        height: '40px',
        '&::before': {
            color: '#009b00 !important',
            fontSize: '20px',
            fontWeight: 'normal',
            content: `url('https://cdn.bdfx.cz/muk/icons/check-slim.svg')`,
            filter: "brightness(0) saturate(100%) invert(40%) sepia(75%) saturate(2412%) hue-rotate(90deg) brightness(92%) contrast(105%)",
            maskImage: 'none',
            background: 'transparent',
        },
    }
}

export const ConfirmStyles = {
    maxWidth: '350px',
    ' .muk-button': {
        width: '100%',
        margin: '0',
    },
    ' .muk-div': {
        borderTop: '0 !important',
        marginTop: '0 !important',
    },
    ' .muk-heading': {
        fontSize: '25px !important',
    },
}

const Style = {
    'html': {
        fontFamily: "'Roboto', Helvetica, Verdana, Sans-serif !important",
        fontSize: '14px !important',
    },
    "body": {
        backgroundColor: inIframe() ? "transparent !important" : "#F1EEE7 !important",
        paddingRight: '15px',
        '@media screen and (max-width: 1024px)': {
            padding: 0,
        },
        margin: '0px !important',
    },
    ".m-arrow-wrapper": {
        display: "none !important",
    },
    ' .m-prefix': {
        height: 'initial !important',
    },
    ' .m-suffix': {
        height: 'initial !important',
    },
    "#app": {
        paddingLeft: "15px",
    },
    ' span.link': {
        color: '#009ba9',
        cursor: 'pointer',
        textDecoration: 'underline',
    },
    //layout:
    "a.muk-button__item": {
        color: "white !important",
    },

    ".document-style": {
        position: "relative",
        margin: "0 auto",
        textAlign: "left",
        paddingLeft: "3px",
        paddingRight: "3px",
    },

    ".showroom": {
        " .togglers": {
            padding: "0 0 0 20px",
            margin: "0 0 20px",
            height: "32px",
            fontSize: "16px",
            background: "hsla(43,44%,75%,.5)",
        },
    },
    ".showroom .togglers .buttons": {
        float: "right",
        textAlign: "right",
        lineHeight: "16px",
    },
    ".showroom .togglers ul": {
        display: "inline-block",
        listStyle: "none",
        padding: 0,
        margin: 0,
    },
    ".showroom .togglers ul li": {
        float: "left",
        paddingRight: "20px"
    },
    ".previews": {
        paddingTop: "35px"
    },
    ".sidebar": {
        padding: "45px 10px 10px 10px"
    },
    ".templates-sidebar": {
        marginTop: "-28px"
    },
    ".togglers": {
        " input[type=checkbox]": {
            margin: "0",
        },

        " .buttons": {
            float: "right",
            textAlign: "right",
        },

        " .button": {
            minHeight: "30px",
            padding: "6px 10px",
        },

        " label": {
            lineHeight: "36px"
        }
    },


    //main:
    ".toast": {
        textAlign: "center"
    },
    "h2": {
        textAlign: "left"
    },
    ".preview-image-raw": {
        minHeight: "50px",
        verticalAlign: 'middle',
        alignSelf: 'center',
        padding: "5px",
        " img": {
            border: "1px dashed #ccc",
        },
        ' .no-preview-image': {
            marginTop: '48%',
        },
    },

    ".react-select-item-search": {
        width: 'calc(100% - 20px)',
        padding: "8px",
        border: "none",
    },

    ".no-preview-image": {
        color: "#666",
        padding: "10px"
    },
    ".template-form": {
        marginTop: "0px",
        " h3.shape-edit-header": {
            marginTop: "0 !important",
        },
        " h2,.shape-edit-header": {
            fontSize: "1.2em",
            padding: "10px 0 5px 2px",
        },
        " hr": {
            display: "block",
            clear: "both",
            height: "0px",
            borderTop: "1px solid #ccc",
            margin: "5px 0",
            opacity: "0.2",
        }
    },
    // background color picker for dynamic element:
    "div.muk-colorpicker__colorbox": {
        height: "38px",
        margin: "1px auto"
    },

    ".hide-native-scrollbar": {
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        '::-webkit-scrollbar': {
            display: 'none',
        }
    },

    // tiny scrollbar
    ".tiny-scrollbar": {
        "::-webkit-scrollbar": {
            width: "5px",
            height: "5px",
        },

        /* Track */
        "::-webkit-scrollbar-track": {
            border: "1px solid #eee",
            borderRadius: "5px",
            background: "#eee",
        },

        /* Handle */
        "::-webkit-scrollbar-thumb": {
            background: "#ccc",
            borderRadius: "5px",
        },

        /* Handle on hover */
        "::-webkit-scrollbar-thumb:hover": {
            background: "#bbb",
        },
    },
    ".muk-radio .LabelRoot": {
        fontSize: "14px",
    },

    //style:
    ".logbook": {
        " h1, h2, h3": {
            margin: "0 !important",
        },
        " hr": {
            height: "1px",
            margin: "10px 0",
            width: "100%",
            display: "block",
            border: "none",
        },
        " ul": {
            listStyle: "none",
            padding: 0,
            margin: 0,
        },
        " .vr": {
            height: "100%",
            margin: "0 20px",
            width: "1px",
            display: "inline-block"
        },
        " header": {
            " .app, .info": {
                display: "inline-block",
            },
            " .app": {
                float: "left",

                " .logo, .logotype": {
                    display: "inline-block",
                    float: "left",
                    height: "120px",
                },

                " img": {
                    width: "100%",
                    height: "100%",
                },

                " .logotype": {
                    padding: "0 30px",
                    lineHeight: "120px",
                    background: "#fff",

                    " h1": {
                        fontSize: "24pt"
                    },
                },
            },
            " .info": {
                float: "right",
                height: "120px",
                position: "relative",

                " h2": {
                    display: "inline-block",
                    lineHeight: "60px",
                    height: "60px",
                },

                " .e-shop": {
                    textAlign: "right",
                },

                " .eshop-logo": {
                    display: "inline-block",
                    background: "#fff",
                    marginLeft: "10px",
                    padding: "10px",
                },

                " .date": {
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    width: "100%",
                    minWidth: "200px",
                    fontSize: "14pt",
                    lineHeight: "50%",

                    " &.faux-row": {
                        height: "60px",
                    },
                    " &.faux-cell": {
                        textAlign: "right",
                        verticalAlign: "bottom",
                    },
                }
            },

        },
        " header + .segment": {
            marginTop: "20px",
        },

        " article.segment + article.segment": {
            marginTop: "20px",
        }
    },
    "div.square-position": {
        backgroundColor: "#E6D7AF",
        width: "128px",
        margin: "auto",
        " input": {
            width: "18px !important",
            height: "18px !important",
            margin: "10px !important",
        }
    },
    "div.wide-position": {
        backgroundColor: "#E6D7AF",
        width: "215px",
        margin: "auto",
        " input": {
            width: "18px !important",
            height: "18px !important",
            margin: "10px !important",
        },
    },
    "div.editor-controls": {
        paddingLeft: "40px",
    },
    "table": {
        fontSize: "10pt",
    },
    "#queries": {
        paddingTop: "-50px",
    },
    "#toasts-container": {
        position: "fixed",
        right: "50px",
        zIndex: 10000,
        textAlign: "center",
    },
    "svg": {
        " .thumb": {
            opacity: 1,
            transition: "opacity 0.2s ease-out"
        },
        " .svg-plus": {
            opacity: 0,
            transition: "opacity 0.45s ease-in-out",
        },
        ":hover": {
            " .thumb": {
                opacity: 0,
            },
            " .svg-plus": {
                opacity: 1
            }
        }
    },
    "h3.shape-edit-header": {
        marginTop: "10px !important"
    },
    ".templates-sidebar .muk-checkbox_container__group": {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis"
    },
    "header.main": {
        margin: "40px 0 0 !important"
    },
    ' .nowrap': {
        whiteSpace: 'nowrap',
    },


    //widget:

    ".widget": {
        display: "block",
        width: "100%",
        height: "100vh",
        overflow: "hidden",

        " img": {
            height: "100%"
        },

        ".widget-left, .widget-right": {
            height: "100%",
            textAlign: "center",
            color: "#333",
            float: "left"
        },

        ".widget-right": {
            paddingTop: "5px",
            width: "60%",
        },
        ".widget-left": {
            width: "40%"
        },
        ".widget-image": {
            height: "100%",
            width: "auto",
            float: "left"
        },
        ".widget-right b, .widget-right p": {
            textAlign: "center"
        },
        ".widget-right b": {
            fontSize: "20pt",
        },
        ".widget-right p": {
            fontSize: "11pt",
            marginTop: "2px !important",
        }
    },
    "#forms-accordion": {
        " h2#accordion-item-header": {
            background: "#e5d7b6",
            padding: "12px",
            fontWeight: "normal",
            border: "1px solid #fff"
        }
    },
    " tr.active-row": {
        background: "#c2ebef",
    },
    ' .react-select-item-options': {
        zIndex: '100 !important',
        maxHeight: '200px',
        overflowY: 'auto',
    },
    ' .shadow-box': {
        boxShadow: '0 0 3px 1px rgba(0,0,0,.3)',
        webkitBoxShadow: '0 0 3px 1px rgba(0,0,0,.3)',
        mozBoxShadow: '0 0 3px 1px rgba(0,0,0,.3)',
    },
    ' .max-height': {
        height: 'inherit',
        ' table.m-table': {
            /*borderBottom: '1px solid #ddd',*/
        },
        ' td.muk-datacell': {
            borderLeft: 0,
            borderRight: 0,
        },
    },
    ' div.muk-form-group.disabled.aspect-ratio': {
        opacity: '.35 !important',
    },
    ' .incognito': {
        filter: isIncognitoOn ? 'blur(10px)' : 'none',
    },
    ' .react-confirm-alert-body': {
        maxHeight: '100vh !important',
        maxWidth: '100vw',
        overflow: 'initial !important',
        padding: '20px',
    },
    ' .react-confirm-alert-body.all-viewtables-modal div.react-confirm-alert > div > .muk-grid': {
        gridGap: '0px !important',
        gridTemplateColumns: 'auto !important',
        height: '100%',
    },
    ' .all-viewtables-modal div.react-confirm-alert > div': {
        minWidth: '60vw !important',
        minHeigh: '60vh !important',
        maxWidth: 'calc(100vw - 40px)',
        maxHeight: 'calc(100vh - 40px)',
        overflow: 'hidden',
    },
    ' .check-elements-modal div.react-confirm-alert > div': {
        minWidth: '60vw !important',
        '&>button': {
            fontSize: '28px',
            fontWeight: 'bold',
        },
        '> div.muk-grid': {
            gridTemplateColumns: 'auto !important',
        },
        ' h2': {
            fontSize: '22px',
            fontWeight: 'bold',
        },
    },
    ' .watermark-groups-marker-modal div.react-confirm-alert > div': {
        width: 'calc(100vw - 40px)',
        height: 'calc(100vh - 40px)',
        maxWidth: 'calc(100vw - 40px)',
        maxHeight: 'calc(100vh - 40px)',
        borderRadius: '0 !important',
    },
    ' .watermarks-modal div.react-confirm-alert > div': {
        width: 'calc(100vw - 40px)',
        height: 'calc(100vh - 40px)',
        maxWidth: 'calc(100vw - 40px)',
        maxHeight: 'calc(100vh - 40px)',
        borderRadius: '0 !important',
    },
    ' .image-preview-modal div.react-confirm-alert > div': {
        width: 'calc(100vw - 6px)',
        height: 'calc(100vh - 6px)',
        '> .muk-grid': {
            gridGap: '0px !important',
            gridTemplateColumns: 'auto !important',
            height: '100%',
        },
        ' .CloseButton': closeButton,
        ' h2': {
            textAlign: 'center',
        },
    },
    ' .wmremove-modal div.react-confirm-alert > div': {
        '&>button': {
            color: 'transparent !important',
            position: 'absolute',
            top: '25px',
            right: '0px',
            pointerEvents: 'auto',
            '&::before': {
                color: '#009ba9 !important',
                fontSize: '20px',
                fontWeight: 'normal',
                lineHeight: '40px',
                verticalAlign: 'middle',
                padding: '8px',
                content: `"${trans('done')}"`,
            },
            fontSize: '38px',
            fontWeight: 'bold',
        },
    },
    ' div#react-confirm-alert .clip-mask-modal .CloseButton': checkButton,
    ' div#react-confirm-alert .bgremove-modal .CloseButton': closeButton,
    ' div#react-confirm-alert .wmremove-modal .CloseButton': closeButton,
    ' .react-confirm-alert-body.save-as-query-modal div.react-confirm-alert > div': {
        ' h2 br': {
            display: 'none',
        },
        minWidth: '90vw',
        '> div.muk-grid': {
            gridTemplateColumns: 'auto !important',
        },
    },
    ' .react-confirm-alert-body.edit-clip-mask-modal div.react-confirm-alert > div': {
        width: 'calc(100vw - 30px)',
        height: 'calc(100vh - 40px)',
        maxWidth: '100vw',
        borderRadius: 0,
        '> div.muk-grid': {
            gridTemplateColumns: 'auto !important',
        },
        '&>button': bigCloseButton,
        ' h2': {
            textAlign: 'center',
        }
    },
    ' .react-confirm-alert-body.select-promo-template': {
        width: 'calc(100vw - 30px)',
        height: 'calc(100vh - 10px)',
        borderRadius: 0,
        '> div.muk-grid': {
            gridTemplateColumns: 'auto !important',
        },
        '&>button': bigCloseButton,
        ' h2': {
            textAlign: 'center',
        }
    },
    ' .react-confirm-alert-body.add-to-watermarks-group-modal div.react-confirm-alert > div': {
        width: '100vw',
        minHeight: 'calc(100vh - 200px)',
        maxWidth: '100vw',
        borderRadius: 0,
        '> div.muk-grid': {
            gridTemplateColumns: 'auto !important',
        },
        ' h2': {
            fontSize: '22px',
            textAlign: 'center',
            alignTop: '16px',
        }
    },
    ' .add-watermarks-group-modal div.react-confirm-alert > div': {
        width: '100vw',
        height: '100vh',
        maxWidth: '100vw',
        padding: '22px !important',
        '> div.muk-grid': {
            gridTemplateColumns: 'auto !important',
            padding: '0px',
        }
    },
    /*     ' .edit-collages-modal div.react-confirm-alert > div': {
            width: '100vw',
            height: '100vh',
            maxWidth: '100vw',
            padding: '0px 3px!important',
            borderRadius: '0 !important',
            '> div.muk-grid': {
                gridTemplateColumns: 'auto !important',
                padding: '40px 10px',
            }
        }, */
    ' .news-box-modal div.react-confirm-alert > div': {
        '@media screen and (min-width: 1024px)': {
            padding: '40px',
        },
        ' h2': {
            fontSize: 'large',
            fontWeight: 'bold',
            paddingTop: '20px',
            margin: '0 0 0 -20px',
            textTransform: 'uppercase',
        },
    },
    ' .react-confirm-alert-body.products-export-modal div.react-confirm-alert > div': {
        borderRadius: 0,
        /* '> button': {
            fontSize: '40px',
        }, */
        ' .muk-icon--question-circle-o': {
            display: 'none',
        },
        ' .react-confirm-alert-button-group': {
            display: 'grid',
            gridAutoRows: 'max-content',
            gridAutoFlow: 'column',
            gridGap: '20px',
        },
        ' .export-button': {
            borderRadius: '2px',
            padding: '10px 16px',
            fontSize: '14px',
        },
        ' .spinner-loader': {
            alignSelf: 'center',
        },
    },
    ' .react-confirm-alert-body.image-preview-wrapper-modal div.react-confirm-alert > div': {
        position: 'relative',
        borderRadius: '2px',
        textAlign: "center",
        maxHeight: "calc(100vh - 50px)",
        '@media screen and (min-width: 1024px)': {
            minWidth: '800px',
        },
        '&>button': bigCloseButton,
        '> div.muk-grid': {
            gridTemplateColumns: 'auto !important',
        },
    },
    ' .import-palette-colors-modal div.react-confirm-alert > div': {
        position: 'relative',
        borderRadius: '0 !important',
        '@media screen and (min-width: 1024px)': {
            minWidth: '800px !important',
        },
        '&>button': bigCloseButton,
        '&>div.muk-grid': {
            gridTemplateColumns: 'auto !important',
        },
    },
    ' .edit-palette-colors-modal div.react-confirm-alert > div': {
        position: 'relative',
        overflowY: 'auto !important',
        background: '#fff !important',
        '@media screen and (min-width: 1024px)': {
            minWidth: '800px !important',
        },
        '&>div.muk-grid': {
            gridTemplateColumns: 'auto !important',
        },
        '&>button': bigCloseButton,
    },
    ' .first-steps-modal div.react-confirm-alert > div': {
        overflowY: 'auto !important',
        "> button": { display: "none" },
        background: '#fff !important',
        '@media screen and (min-width: 1024px)': {
            width: '60vw',
        },
        '> div.muk-grid': {
            gridTemplateColumns: 'auto !important',
        },
        '> h2': {
            fontWeight: 700,
            fontSize: '30px',
            lineHeight: '40px',
        },
    },
    ' .watermark-removal-confirm': {
        width: '95vw',
    },
    /*' .react-confirm-alert-body > .muk-grid': {
        gridTemplateColumns: 'auto',
    },*/
    ' .watermarks-modal div.react-confirm-alert > div > button, .products-modal div.react-confirm-alert > div > button, .validations-modal div.react-confirm-alert > div > button, .image-quality-modal div.react-confirm-alert > div > button': {
        fontSize: '40px',
    },
    ' div.react-confirm-alert-body.watermarks-modal div.react-confirm-alert > div > div.muk-grid': {
        gridTemplateColumns: 'auto',
    },
    ' .unselectable': {
        mozUserSelect: '-moz-none',
        webkitUserSelect: 'none',
        msUserSelect: 'none',
        userSelect: 'none',
    },
    ' .clickable': {
        cursor: 'pointer',
    },
    ' .checker': {
        backgroundImage: `linear-gradient(45deg, ${checkerColor} 25%, transparent 25%),linear-gradient(135deg, ${checkerColor} 25%, transparent 25%),linear-gradient(45deg, transparent 75%, ${checkerColor} 75%),linear-gradient(135deg, transparent 75%, ${checkerColor} 75%)`,
        backgroundSize: '25px 25px',
        backgroundPosition: '0 0, 12.5px 0, 12.5px -12.5px, 0px 12.5px',
    },

    "input:checked + .muk-checkbox-input .muk-icon--check": {
        verticalAlign: "text-bottom",
    },

    ".m-header .m-actions.muk-div": {
        "button.muk-button": {
            padding: "5px",
        },
    },
    ' .above-undo-redo': {
        zIndex: 101,  /*above undo-redo buttons!*/
    },
    ' .muk-nav': {
        gridGap: '0 !important',
    },
    ' .muk-nav .muk-navlink ': {
        /*borderRadius: '10px !important',*/
        marginRight: '0px !important',
    },
    ' li.muk-navlink a': {
        textDecoration: 'none !important',
    },
    ' div.react-confirm-alert-body.create-predefined-fie-queries': {
        ' h2': {
            fontSize: 'large',
            fontWeight: 'bold',
        },
        ' .react-confirm-alert-button-wrapper': {
            margin: 0,
        }
    },
    ' div.react-confirm-alert-body.new-template-modal div.react-confirm-alert > div': {
        ' h2': {
            fontSize: 'large',
            fontWeight: 'bold',
            paddingTop: '20px',
        },
    },
    ' .some-users-only': {
        background: `radial-gradient(${Theme.yellow}ee, #ffffff00) !important`,
        border: `1px dashed ${Theme.yellow}`,
        color: '#000 !important',
        ' div.muk-grid.m-header,input': {
            background: `radial-gradient(${Theme.yellow}ee, #ffffff00) !important`,
        },
    },
    ' .active-filter': {
        border: `1px solid ${Theme.steelblue}14 !important`,
        borderRadius: '10px',
    },
    ' .big-only': {
        '@media screen and (max-width: 1024px)': {
            display: 'none',
            visibility: 'hidden',
        }
    },
    ' .disabled-link': {
        pointerEvents: 'none',
    },
    ' .framed': {
        cursor: 'default',
        textTransform: 'uppercase',
        border: '1px solid ' + Theme.grey,
        borderRadius: '3px',
        padding: '4px 3px',
        margin: '2px',
        whiteSpace: 'nowrap',
        lineHeight: '1em',
        fontSize: '.8em',
        color: Theme.steelblue,
        background: '#f6f7f8a2',
    },
    ' .filter-color': {
        filter: "brightness(0) saturate(100%) invert(40%) sepia(75%) saturate(2412%) hue-rotate(156deg) brightness(92%) contrast(105%)",
    },
    ' .flip-x img.m-image': {
        webkitTransform: 'scaleX(-1)',
        transform: 'scaleX(-1)',
    },
    ' .hide-buttons .m-field-muk-input-radio button': {
        display: 'none',
    },
    ' .horizontal-fixed-size .m-radio-wrapper': {
        gridTemplateColumns: 'repeat(auto-fit, minmax(25%, 1fr))',
        gridAutoFlow: 'row !important',
    },
    ' .m-image+.muk-icon__text': {
        marginLeft: 'initial !important',
    },
    ".center": {
        textAlign: "center"
    },
    ' #canvas-wrapper': {
        padding: '3px',
        position: 'relative',
    },
    ' .mouse-select__selectable.selected': {
        outline: `dashed ${Theme.steelblue} 4px`,
    },
    ' .mouse-select__frame': {
        background: Theme.steelblue,
        opacity: .3,
        zIndex: 999999,
    },
    ' table': {
        borderSpacing: 'initial',
    },
    ' .muk-grid .muk-message__wrapper': {
        width: 'auto',
        margin: '10px 0px',
    },
    ".mus-select > div[class*=control]": {
        minHeight: "40px",
        background: '#ffffff',
    },
    "&.active .mus-select>div[class*=control]": {
        background: "#fffbd6",
    },
    ' .muk-textinput input': {
        height: '40px !important',
        lineHeight: '40px !important',
    }
}

export default Style


function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}
